
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth'
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'


const firebaseConfig = {
    apiKey: "AIzaSyDka90ycIX4q2Z1zzvl6_doRbGm1usH7mQ",
    authDomain: "elqanas-store.firebaseapp.com",
    projectId: "elqanas-store",
    storageBucket: "elqanas-store.appspot.com",
    messagingSenderId: "1008880347116",
    appId: "1:1008880347116:web:4afb81310806cf298542c9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

export default app